exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".automation-card .automation-card-content[data-v-2c82f0d2] {\n  background-color: white;\n  padding: 16px;\n}", ""]);

// exports
